export const DEFAULT_OWNERSHIP_VALUE = 25;
